import React from 'react'
import './FullScreenLoader.css'

/** Full-screen loader shown while the session is being verified. */
const FullScreenLoader: React.FC = () => (
  <div className="fsl-overlay" role="status" aria-live="polite">
    <div className="fsl-spinner" aria-hidden="true" />
    <span className="fsl-label">読み込み中…</span>
  </div>
)

export default FullScreenLoader
